import { lazy } from "react";
// Note: make sure path is in lower case

export const routes = {
  // Standalone Health App Pages
  healthOverview: {
    path: "/overview",
    element: lazy(() => import("../../pages/HealthOverview")),
  },
  healthChat: {
    path: "/chat",
    element: lazy(() => import("../../pages/HealthChat")),
  },
  healthCare: {
    path: "/care",
    element: lazy(() => import("../../pages/HealthCare")),
  },
  healthReminders: {
    path: "/reminders",
    element: lazy(() => import("../../pages/HealthReminders")),
  },
  aiCoach: {
    path: "/ai-coach",
    element: lazy(() => import("../../pages/AICoach")),
  },
  // AI Coach with conversation parameter (for continuing existing chats)
  aiCoachConversation: {
    path: "/ai-coach/:conversationId",
    element: lazy(() => import("../../pages/AICoach")),
  },
  caregiver: {
    path: "/caregiver",
    element: lazy(() => import("../../pages/Caregiver")),
  },
  login: {
    path: "/login",
    // Redirect to proper location - uses RedirectElement to handle home health users
    element: lazy(() => import("./redirectElement")),
  },

  changePassword: {
    path: "/change-password",
    element: lazy(() => import("../../pages/ChangePassword")),
  },
  changePin: {
    path: "/change-pin",
    element: lazy(() => import("../../pages/ChangePin")),
  },

  contactSupport: {
    path: "/contact-support",
    element: lazy(() => import("../../pages/ContactSupport")),
  },

  intendedUse: {
    path: "/intended-use",
    element: lazy(() => import("../../pages/IntendedUser")),
  },

  faq: {
    path: "/faq",
    element: lazy(() => import("../../pages/Faq")),
  },

  feedback: {
    path: "/feedback",
    element: lazy(() => import("../../pages/Feedback")),
  },
  notificationSettings: {
    path: "/notification-settings",
    element: lazy(() => import("../../pages/NotificationSettings")),
  },
  reportAProblem: {
    path: "/reportAProblem",
    element: lazy(() => import("../../pages/ReportAProblem")),
  },
  rateApp: {
    path: "/rateApp",
    element: lazy(() => import("../../pages/RateApp")),
  },
  privacyPolicy: {
    path: "/privacyPolicy",
    element: lazy(() => import("../../pages/PrivacyPolicy")),
  },
  settings: {
    path: "/settings",
    element: lazy(() => import("../../pages/Settings")),
  },
  SummaryScreen: {
    path: "/summary",
    element: lazy(() => import("../../pages/SummaryScreen")),
  },
  userInfo: {
    path: "/user-info",
    element: lazy(() => import("../../pages/UserInfo")),
  },
  logout: {
    path: "/logout",
    element: lazy(() => import("../../pages/LogoutPage")),
  },
  // ⛔️ADD MORE ROUTE ABOVE THIS LINE⛔️
  redirectElementStar: {
    path: "*",
    element: lazy(() => import("./redirectElement")),
  },
  redirectElement: {
    path: "",
    element: lazy(() => import("./redirectElement")),
  },
  termsOfUse: {
    path: "/terms-of-use",
    element: lazy(() => import("../../pages/TermsOfUse")),
  },
} as const;
